import { PriceListRequestCollectionModel, getPriceListRequest } from "@NA/Services/ADIPriceListRequest.service";
import { getBannerCarousel } from "@NA/Services/GetBannerCarousel";
import { getVisualCarousal, visualCarousalParams, VisualFilterCarousal } from "@NA/Services/GetVisualCarousal";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { BrandPriceList } from "@NA/Store/Data/ADIRequestPriceListState";
import { HasOnError, HasOnSuccess, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<PriceListRequestCollectionModel & HasOnSuccess & HasOnError, any>;

export const DispatchPriceList: HandlerType = (props: any) => {
    props.parameter.expand = "properties";
    props.dispatch({
        type: "Custom/LoadPriceList",
        result: props.parameter,
    });
};

export const LoadPriceList: HandlerType = async (props: any) => {
    try {
        props.apiResult = await getPriceListRequest(props.parameter);
        if (props.apiResult) {
            props.parameter.onSuccess(props.apiResult);
        }
    } catch (err) {
        props.parameter.onError(null);
        console.info(err, "err fetching getPriceListRequest ");
    }
    props.parameter.onSuccess(props.apiResult);
};

export const DispatchCompletePriceList: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompletePriceList",
        visualFilter: props.apiResult,
    });
};

export const chain = [DispatchPriceList, LoadPriceList, DispatchCompletePriceList];

const priceList = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        BrandsRequested: [],
        RequestHeader: {
            requestVersion: " ",
            requestId: " ",
            customerNumber: " ",
            userID: " ",
            userEmail: " ",
            returnCode: " ",
            returnMessage: " ",
            recordCount: " ",
        },
        uri: " ",
        properties: {},
        status: 0,
        onSuccess: (result: any) => { },
        onError: (error: any) => { }
    },
    "PriceList",
);
export default priceList;
